export default "__VITE_ASSET__ff0e4e6b__"